module.exports = __webpack_public_path__ + "src/assets/img/balashihinskaya.fbac8a3c.jpg";